import React from "react";
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography, Paper, Grid } from "@mui/material";

const VendorDetailsToAdmin = ({
  vendorDetails,
  onBack,
  openImage,
  selectedImage,
  handleImageClick,
  handleCloseImage,
}) => {
  return (
    <Box sx={{ padding: "20px" }}>
      {/* Back Button */}
      <Button
        variant="contained"
        color="secondary"
        onClick={onBack}
        sx={{ position: "absolute", top: "20px", left: "20px" }}
      >
        Back
      </Button>

      {vendorDetails ? (
        <Box sx={{ textAlign: "center", maxWidth: "800px", margin: "auto" }}>
          {/* Card for Details */}
          <Paper
            elevation={3}
            sx={{
              padding: "30px",
              borderRadius: "12px",
              textAlign: "left",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            {/* Owner Image */}
            <Box sx={{ textAlign: "center", marginBottom: "30px" }}>
              {vendorDetails.OwnerImage.length > 0 ? (
                vendorDetails.OwnerImage.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt="Owner"
                    onClick={() => handleImageClick(image)}
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                      cursor: "pointer",
                      borderRadius: "50%",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                      margin: "10px auto",
                    }}
                  />
                ))
              ) : (
                // Display a circle with the text "No Image Available"
                <Box
                  sx={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "50%",
                    backgroundColor: "#e0e0e0",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    margin: "10px auto",
                  }}
                  onClick={() => handleImageClick("")} // Click handler even for no image
                >
                  <Typography variant="body1" sx={{ color: "#777", fontSize: "1rem" }}>
                    No Image Available
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Business Details */}
            <Typography gutterBottom sx={{ textAlign: "center", fontSize: "2.0rem", marginBottom: "20px" }}>
              Business Details
            </Typography>

            <Grid container spacing={3} paddingLeft={10}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ fontSize: "1.2rem", paddingLeft: "10px" }}>
                  <strong>Business Name:</strong> {vendorDetails.BusinessName || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ fontSize: "1.2rem", paddingLeft: "10px" }}>
                  <strong>Created At:</strong> {vendorDetails.createdAt || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ fontSize: "1.2rem", paddingLeft: "10px" }}>
                  <strong>Vendor Ratings:</strong> {vendorDetails.VenderOverallRatings || "N/A"}
                </Typography>
              </Grid>
            </Grid>

            <Typography gutterBottom sx={{ textAlign: "center", fontSize: "2.0rem", marginBottom: "20px" }}>
              Vendor Details
            </Typography>

            <Grid container spacing={3} paddingLeft={10}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ fontSize: "1.2rem", paddingLeft: "10px" }}>
                  <strong>Owner Name:</strong> {vendorDetails.OwnerName || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ fontSize: "1.2rem", paddingLeft: "10px" }}>
                  <strong>Email:</strong> {vendorDetails.OwnerEmail || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ fontSize: "1.2rem", paddingLeft: "10px" }}>
                  <strong>Mobile:</strong> {vendorDetails.OwnerMobile_number || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ fontSize: "1.2rem", paddingLeft: "10px" }}>
                  <strong>Address:</strong> {vendorDetails.OwnerADDRESS || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ fontSize: "1.2rem", paddingLeft: "10px" }}>
                  <strong>DOB:</strong> {vendorDetails.OwnerDOB || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ fontSize: "1.2rem", paddingLeft: "10px" }}>
                  <strong>Gender:</strong> {vendorDetails.OwnerGender || "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ fontSize: "1.2rem", paddingLeft: "10px" }}>
                  <strong>WhatsApp:</strong> {vendorDetails.OwnerWhatsapp_number || "N/A"}
                </Typography>
              </Grid>
            </Grid>
          </Paper>

          {/* Image Popup */}
          <Dialog open={openImage} onClose={handleCloseImage}>
            <DialogTitle>Image Preview</DialogTitle>
            <DialogContent>
              {selectedImage && (
                <img
                  src={selectedImage}
                  alt="Full Size"
                  style={{ width: "100%", height: "auto" }}
                />
              )}
            </DialogContent>
          </Dialog>
        </Box>
      ) : (
        <Typography variant="body1" align="center" sx={{ fontSize: "1.2rem" }}>
          Loading...
        </Typography>
      )}
    </Box>
  );
};

export default VendorDetailsToAdmin;
